<div class="item-bank-list-container" *ngIf="!setAddSchedule && isPublished && !isEditEnabled">
  <div class="module-wrapper content-wrapper">
    <mat-card class="mat-c">
      <mat-card-content>
        <div class="head-container">
          <span class="spacer"></span>
          <div>
            <div class="btn-wrapper">
              <button mat-flat-button color="" class="btn-warn" aria-label="Add New Schedule" (click)='newSchedule()'
                [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true)">
                + {{'testId.TabSchedules.btnSchedule' | translate}}</button>
            </div>

          </div>
        </div>
        <div class="input-container schedule-container">
          <div class="input-fields-wrapper">
            <div class="input-wrapper">
              <mat-form-field class="example-full-width custom-date-picker" appearance="fill">
                <input matInput placeholder="{{'testId.TabSchedules.dateFrom' | translate}}" [matDatepicker]="picker"
                  [(ngModel)]='fromDate' readonly>
                <mat-datepicker-toggle matSuffix [for]="picker">
                  <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="example-full-width custom-date-picker" appearance="fill">
                <input type="text" matInput placeholder="{{'testId.TabSchedules.dateTo' | translate}}"
                  [matDatepicker]="picker1" [(ngModel)]='toDate' readonly>
                <mat-datepicker-toggle matSuffix [for]="picker1">
                  <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>

              <input type="text" [(ngModel)]='scheduleName'
                placeholder="{{'testId.TabSchedules.labelSchName' | translate}}"
                class="form-control ng-untouched ng-pristine ng-valid  sch-wrapper" ng-reflect-model="">
              <select aria-placeholder="Status" [(ngModel)]='scheduleType'
                class="form-control ng-untouched ng-pristine ng-valid  sch-wrapper" ng-reflect-model="">
                <option value="" ng-reflect-value="">{{'testId.TabSchedules.schedule.option1' | translate}}</option>
                <option value="true" ng-reflect-value="true">{{'testId.TabSchedules.schedule.option2' | translate}}
                </option>
                <option value="false" ng-reflect-value="false">{{'testId.TabSchedules.schedule.option3' | translate}}
                </option>
              </select>
            </div>
            <div class="btn-wrapper">
              <button mat-flat-button color="" class="btn-primary" (click)='filterSchedule()'
                aria-label="Search">{{'testId.TabSchedules.btnSearch' | translate}}</button>
              <button mat-flat-button color="" class="btn-flat" (click)='resetFilter()'
                aria-label="Reset">{{'testId.TabSchedules.btnReset' | translate}}</button>
            </div>
          </div>
        </div>

        <div *ngIf="isNoItems" class="data-not-found-container table-container">
          <span>{{'testId.TabSchedules.noSchMsg' | translate}}</span>
        </div>
        <div *ngIf="!isNoItems">

          <div class="table-container">
            <table mat-table [dataSource]="schedule" matSort class="mat-elevation-z8">
              <ng-container matColumnDef="schedulename">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'testId.TabSchedules.column1' |
                  translate}}</th>
                <td class="text-focus" mat-cell *matCellDef="let row"
                  (click)='(roleSer.accessData?!roleSer.accessData.updateAllowed :true) ? "" : navigateToScheduleDetails(row)'>
                  <ng-container *ngIf="row?.title?.length > 40 then sliceTitle else noSliceTitle">
                  </ng-container>
                  <ng-template #sliceTitle>
                    <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{row?.title}}"
                      matTooltipPosition="above">
                      {{row?.title | slice: 0:50}}...</div>
                  </ng-template>
                  <ng-template #noSliceTitle>
                    <div class="text-bold">{{row?.title }}</div>
                  </ng-template>
                </td>
              </ng-container>


              <ng-container matColumnDef="testType">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'testId.TabSchedules.column2' |
                  translate}}</th>
                <td class="text-focus" mat-cell *matCellDef="let row"
                  (click)='(roleSer.accessData?!roleSer.accessData.updateAllowed :true) ? "" : navigateToScheduleDetails(row)'>
                  <span *ngIf="row.scheduleType==true">{{'testId.TabSchedules.labelPublic' | translate}}</span>
                  <span *ngIf="row.scheduleType==false">{{'testId.TabSchedules.labelPrivate' | translate}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="startdate">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'testId.TabSchedules.column3' |
                  translate}}</th>
                <td class="text-focus" mat-cell *matCellDef="let row"
                  (click)='(roleSer.accessData?!roleSer.accessData.updateAllowed :true) ? "" : navigateToScheduleDetails(row)'>
                  <span>
                    {{row.startDate}} {{row.startDateHours}}:{{row.startDateMinutes}} <br>
                    <span>{{row.timeZonesName}}</span>
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="enddate">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'testId.TabSchedules.column4' |
                  translate}}</th>
                <td class="text-focus" mat-cell *matCellDef="let row"
                  (click)='(roleSer.accessData?!roleSer.accessData.updateAllowed :true) ? "" : navigateToScheduleDetails(row)'>
                  <span>
                    {{row.endDate}} {{row.endDateHours}}:{{row.endDateMinutes}} <br>
                    <span>{{row.timeZonesName}}</span>
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'testId.TabSchedules.column5' |
                  translate}}</th>
                <td class="text-focus" mat-cell *matCellDef="let row"
                  (click)='(roleSer.accessData?!roleSer.accessData.updateAllowed :true) ? "" : navigateToScheduleDetails(row)'>
                  <span>{{row.scheduleStatus}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="examineecount">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'testId.TabSchedules.column6' |
                  translate}}</th>
                <td class="text-focus" mat-cell *matCellDef="let row"
                  (click)='(roleSer.accessData?!roleSer.accessData.updateAllowed :true) ? "" : navigateToScheduleDetails(row)'>
                  <span> {{row.examineeCount}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="examineeattempted">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'testId.TabSchedules.column7' |
                  translate}} </th>
                <td class="text-focus" mat-cell *matCellDef="let row"
                  (click)='(roleSer.accessData?!roleSer.accessData.updateAllowed :true) ? "" : navigateToScheduleDetails(row)'>
                  <span> {{row.examineeAttempted}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="testurl">
                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'testId.TabSchedules.column8' |
                  translate}} </th>
                <td mat-cell *matCellDef="let row">
                  <button mat-icon-button (click)='navigateToScheduleDetails(row)'
                    [ngClass]="{disableIcon : (roleSer.accessData?!roleSer.accessData.updateAllowed :true)}"
                    matTooltip="{{'testId.TabSchedules.toolTip.edit' | translate}}">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button (click)="openTestUrlDialog(row?.testUrl)"
                    [ngClass]="{disableIcon : (roleSer.accessData?!roleSer.accessData.updateAllowed :true || roleSer.accessData?!roleSer.accessData.insertAllowed :true)}"
                    matTooltip="{{'testId.TabSchedules.toolTip.test' | translate}}">
                    <mat-icon>file_copy</mat-icon>
                  </button>


                  <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)='navigateToScheduleDetails(row)'
                      [disabled]="(roleSer.accessData?!roleSer.accessData.updateAllowed :true)">
                      <mat-icon>edit</mat-icon>
                      <span>{{'testId.TabSchedules.toolTip.edit' | translate}}</span>
                    </button>
                    <button mat-menu-item (click)="openTestUrlDialog(row?.testUrl)"
                    [disabled]="(roleSer.accessData?!roleSer.accessData.updateAllowed :true || roleSer.accessData?!roleSer.accessData.insertAllowed :true)">
                      <mat-icon>file_copy</mat-icon>
                      <span>{{'testId.TabSchedules.toolTip.test' | translate}}</span>
                    </button>
                  </mat-menu> -->
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div class="data-not-found-container" *ngIf='noDataFound'>
              <p>{{'testId.TabSchedules.errorMsg' | translate}}</p>
            </div>
          </div>


        </div>
        <div class="schedule-paginator" *ngIf="schedateDatacount > 0">
          <mat-paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div *ngIf="isPublished==false">
  <h4>{{'testId.TabSchedules.ScheduleErrorMsg' | translate}}</h4>
</div>
<div *ngIf="setAddSchedule && !isEditEnabled">
  <app-add-tests-new-schedule></app-add-tests-new-schedule>
</div>
<div *ngIf="!setAddSchedule && isEditEnabled">
  <app-edit-tests-schedule></app-edit-tests-schedule>
</div>